import { browser } from '$app/environment';

export const getFromLocalStorage = (key: string) => {
  if (browser) {
    const value = localStorage.getItem(key);

    if (value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        throw new Error(`Can't parse value from localStorage by key: ${key}`);
      }
    }
  }
};
